import { useParams } from "react-router-dom";
import EditForm from "../components/Form/EditForm";
import { useGetProjectsQuery } from "../redux/features/projects/projectsApi";
import { useGetTaskQuery } from "../redux/features/tasks/taskApi";
import { useGetTeamQuery } from "../redux/features/Team/teamApi";


export default function EditTask() {
  const prams = useParams();
  const { data: task, isLoading: taskLoading, isError: taskError } = useGetTaskQuery(prams.taskId)
  const { data: team, isLoading: teamLoading, isError: TeamError } = useGetTeamQuery();
  const { data: projects, isLoading, isError } = useGetProjectsQuery();

  let editForm = null;
  if (!taskLoading && !isLoading && !teamLoading && !taskError && !isError && !TeamError && task?.id && team?.length > 0 && projects?.length > 0 ) {
    editForm = <EditForm task={task} team={team} projects={projects} />
  }
  return <>
    {(isLoading || teamLoading || taskLoading) ? <div className="text-center">Loading...</div> : <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Edit Task
        </h1>
        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          {editForm}
        </div>
      </main>
    </div>}
  </>
};